import { Component, Input, ViewEncapsulation } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { IPlatformUser } from '@nova/common-interfaces';
import { AuthenticatedHeaderComponent } from '../shared/components/auth/authenticated-header/authenticated-header.component.mjs';
import { AuthService } from '../shared/services/auth/auth.service';
import { AdminSidebarComponent } from './layout/admin-sidebar/admin-sidebar.component';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [AdminSidebarComponent, RouterOutlet, AuthenticatedHeaderComponent, CommonModule],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AdminDashboardComponent {
  isToggled = false;
  @Input()
  user: IPlatformUser | undefined;

  constructor(private authService: AuthService, router: Router) {
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.user = { ...user } as unknown as IPlatformUser;
      }
      else
      {
        console.log(window.location);
        if (!window.location.pathname.toLowerCase().includes("login") &&
        !window.location.pathname.toLowerCase().includes("register") &&
        !window.location.pathname.toLowerCase().includes("reset-password"))
        {
          router.navigate(["/login"]);
        }
      }
    });  }

  handleToggle(newState: boolean) {
    this.isToggled = newState;
  }

  handleCollapse(newState: boolean) {
    this.isToggled = newState;
  }
}
